export default __webpack_public_path__ + "static/media/notifications_4.d3585e55.png";